import objectFitImages from 'object-fit-images';

const ObjFit = () => {
  objectFitImages();
};

export default ObjFit;


// WEBPACK FOOTER //
// ./src/recruit/js/objFit.js